<template>
  <user-domains />
</template>

<script>
import UserDomains from "@/components/Ondemand/Domains/Index.vue";

export default {
  components: {
    UserDomains,
  },
};
</script>

<style></style>
